const Tab = ({ label, isActive, onClick }) => (
  <button
    onClick={onClick}
    className={`px-4 py-2 text-sm font-MTNfont border-b-2 transition-colors duration-200 ${
      isActive
        ? "border-[#FFCC00] text-[#FFCC00]"
        : "border-transparent text-gray-500 hover:text-gray-700"
    }`}
  >
    {label}
  </button>
);

export default Tab;
